module.exports = __webpack_public_path__ + "static/media/padel.8d5dfb58.svg";